<template>
  <div class="team">
    <v-container >
      <v-layout row wrap>
         <v-flex
            sm12
            xs12
            md12
            lg12
          >
          <template>
            <v-card>
              <v-toolbar color="#008a43" flat><h3 class="white--text">Công cụ</h3></v-toolbar>
              <v-card-title>
                <v-row>
                 <v-col
                    sm6
                    xs4
                    md4
                    lg4
                  >
                    <v-text-field
                      v-model="filter.BienSoXe"
                      :rules="rules.BienSo"
                      counter="9"
                      label="Biển số"
                      hint="Tìm kiếm bằng biển số xe"
                      persistent-hint
                      outlined
                      persistent-placeholder
                    ></v-text-field>
                 </v-col>
                 <v-col
                    sm6
                    xs4
                    md4
                    lg4
                  >
                    <v-select
                      v-model="filter.LoaiXe"
                      :items="LoaiXe"
                      label="Loại xe"
                      item-value="Value"
                      item-text="Text"
                      outlined
                    ></v-select>
                 </v-col>
                 <v-col
                    sm6
                    xs3
                    md3
                    lg3
                  >
                  <v-btn-toggle>
                    <v-btn color="#008a43" class="white--text" @click=TimKiem>Tìm kiếm <v-icon right>mdi mdi-clipboard-text-search-outline</v-icon> </v-btn>
                    <Manager :Rules="rules" :isUpdated.sync="isUpdated" :ShowButton=true :LoaiXe="LoaiXe.slice(1)" :Tram="Tram" ref="UpdateItem" />
                  </v-btn-toggle>
                 </v-col>
                </v-row>
              </v-card-title>              
            </v-card>
            <br />
          </template>
         </v-flex>
         <v-flex
            sm12
            xs12
            md12
            lg12
          >
          <template>
            <v-card>
              <v-toolbar color="#008a43" flat><h3 class="white--text">Danh sách</h3></v-toolbar>
              <v-card-title>
                <v-row>
                  <v-spacer></v-spacer>
                  <v-col
                    cols="12"
                    md="6"
                    lg="4"
                  >
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Tìm kiếm"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-data-table
                :loading="loading"
                :headers="headers"
                :items="DanhSachMoi"
                :search="search"
                loading-text="Đang tải dữ liệu..."
                :footer-props="{itemsPerPageText: 'Dữ liệu mỗi trang','items-per-page-options':[10,20,30,40,50]}"
                :items-per-page="20"
              >
              <template v-slot:no-data>
                <br />
                <v-alert
                  border="right"
                  colored-border
                  type="warning"
                >
                  <v-btn text color="warning">Không có dữ liệu</v-btn>
                </v-alert>
              </template>
              <template v-slot:[`item.ThoiGian`]="{ item }">
                <v-btn
                  text
                  small
                >
                    {{moment(item.ThoiGian).tz("Asia/Bangkok").format("DD-MM-YYYY HH:mm")}}
                  </v-btn>
              </template>
              <template v-slot:[`item.HinhAnh`]="{ item }">
                <v-btn
                  text
                  small
                  v-if="item.HinhAnh"
                  @click="LoadImage(item)"
                >
                    Xem Hình Ảnh
                  </v-btn>
              </template>
              <template v-slot:[`item.LoaiXe`]="{ item }">
                <v-btn
                  text
                  small
                >
                    {{LoaiXe[item.LoaiXe].Text}}
                  </v-btn>
              </template>
              <template v-slot:[`item.gtId`]="{ item }">
                    <ControlButton :Item="item" :EditFunc="ChinhSua" :DeleteFunc="Xoa"/>
              </template>
              </v-data-table>
            </v-card>
          </template>
         </v-flex>
      </v-layout>
    </v-container>
    <template>
      <div>
        <VueEasyLightbox
          :visible="visible"
          :imgs="imgs"
          @hide="hideImage"
        ></VueEasyLightbox>
      </div>
    </template>
  </div>
</template>

<script>
import Manager from '../components/GTXManager.vue'
import ControlButton from '../components/ControlButton.vue'
import VueEasyLightbox from 'vue-easy-lightbox'
export default {
  name: 'giay-to-xe',
  components: {
    Manager,
    ControlButton,
    VueEasyLightbox
  },
  computed: {
    DanhSachMoi: function(){
        return this.DanhSach.map(
          (items, index) => ({
            ...items,
            index: index + 1
          }))
      }
  },
  methods: {
    LoadImage: function(item){
      this.imgs = `${this.$API_URL}/du-lieu/dangky-dangkiem/${item.HinhAnh}`;
      this.visible = true;
    },
    hideImage() {
      this.visible = false;
      this.imgs = '';
    },
    ChinhSua: function(item){
      if(!item.gtId)
      {
        return;
      }
      this.loading = true;
      this.$Request.get(`/giaytoxe/${item.gtId}`).then(response => {
          const json = response.data;
          if(json.success === true)
          {
            this.$refs.UpdateItem.EditItem(json.data);
          }else{
            const msg = json.error || "Không tải được dữ liệu !!!";
            this.$swal.fire({
                position: 'center',
                icon: 'error',
                title: msg,
                showConfirmButton: false,
                timer: 1500
            });
          }
      }).catch((error) =>{
          console.log(error);
          this.$swal.fire({
              position: 'center',
              icon: 'error',
              title: "Không tải được dữ liệu !!!",
              showConfirmButton: false,
              timer: 1500
          });
        }).finally(()=>{
        this.loading = false;
      });
    },
    Xoa: async function(item){
      if(!item.gtId)
      {
        return;
      }
      const result = await this.$swal.fire({
        title: 'Bạn có chắc chắn?',
        text: "Hành động này sẽ không thể phục hồi được dữ liệu !!!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Hủy',
        confirmButtonText: 'Xác nhận xóa'
      });
      if(result.isConfirmed === false)
      {
        return;
      }
      this.loading = true;
      this.$Request.delete(`/giaytoxe/${item.gtId}`).then(response => {
          const json = response.data;
          if(json.success === true)
          {
            this.LayDulieu();
            const msg = response.data.msg || "Đã xóa thành công !";
            this.$swal.fire({
                position: 'center',
                icon: 'success',
                title: msg,
                showConfirmButton: false,
                timer: 1500
            });
          }else{
            const msg = json.error || "Không tải được dữ liệu !!!";
            this.$swal.fire({
                position: 'center',
                icon: 'error',
                title: msg,
                showConfirmButton: false,
                timer: 1500
            });
          }
      }).catch((error) =>{
          console.log(error);
          this.$swal.fire({
              position: 'center',
              icon: 'error',
              title: "Không tải được dữ liệu !!!",
              showConfirmButton: false,
              timer: 1500
          });
        }).finally(()=>{
        this.loading = false;
      });
    },
    TimKiem: function(){
      this.loading = true;
      this.$Request.post('/giaytoxe',this.filter).then(response => {
          this.DanhSach = response.data.data;
      }).finally(()=>{
        this.loading = false;
      });
    },
    LayDulieu: function(){
      this.loading = true;
      this.$Request.get(`/giaytoxe`).then(response => {
          const data = response.data;
          this.Tram = data.Tram;
          this.DanhSach = data.DanhSach;
      }).catch(() =>{
          this.$swal.fire({
              position: 'center',
              icon: 'error',
              title: "Không tải được dữ liệu !!!",
              showConfirmButton: false,
              timer: 1500
          });
        }).finally(()=>{
        this.loading = false;
      });
    },
  },
  watch: {
    isUpdated:function(val)
    {
      if(val === true)
      {
        this.isUpdated = undefined;
        this.LayDulieu();
      }
    },
  },
  data : () => ({
    imgs: "",
    visible: false,
    isUpdated: undefined,
    loading: false,
    filter:{
      BienSoXe: "",
      LoaiXe: null,
    },
    rules: {
      BienSo: [v => (v.length <= 9 && v.length >= 7) || 'BKS phải từ 7-9 kí tự'],
      YeuCau: [v => !!v || 'Điền dữ liệu vào !!!']
    },
    Tram: [],
    LoaiXe: [{Value:null,Text:"TẤT CẢ"},{Value:1,Text:"Loại 1"},{Value:2,Text:"Loại 2"},{Value:3,Text:"Loại 3"},{Value:4,Text:"Loại 4"},{Value:5,Text:"Loại 5"}],
    DanhSach: [],
    search: "",
    headers: [
        { text: 'STT', align: 'center', sortable: true,value: 'index',width:"5%",class:"grey lighten-2 black--text" },
        { text: 'Trạm', align: 'center', sortable: false,value: 'station.StationsName',width:"10%",class:"grey lighten-2 black--text" },
        { text: 'Biển số xe', align: 'center', sortable: true,value: 'BienSoXe',width:"20%",class:"grey lighten-2 black--text" },
        { text: 'Đăng kiểm', align: 'center', sortable: false,value: 'DangKiem',width: "15%",class:"grey lighten-2 black--text" },
        { text: 'Đăng ký', align: 'center', sortable: false,value: 'DangKy',width: "5%",class:"grey lighten-2 black--text" },
        { text: 'Loại xe', align: 'center', sortable: false,value: 'LoaiXe',width: "15%",class:"grey lighten-2 black--text" },
        { text: 'Hình ảnh', align: 'center', sortable: false,value: 'HinhAnh',width: "10%",class:"grey lighten-2 black--text" },
        { text: 'Thời gian', align: 'center', sortable: false,value: 'ThoiGian',width: "10%",class:"grey lighten-2 black--text" },
        { text: 'Thao tác', align: 'center', sortable: false,value: 'gtId',width: "10%",class:"grey lighten-2 black--text" },
    ],
  }),
  mounted(){
    this.LayDulieu();
  }
}
</script>
